export default __webpack_public_path__ + "static/media/tentorium-1024.6b8ce81c.png";